// =============================================================================
// FILE:
// frontend/src/ipe/pms/services/siteStoreExecutionService.js
// =============================================================================

import axiosClient
  from "../../../api/axiosClient";


// =============================================================================
// GET MATERIAL ISSUE LIST
// =============================================================================

export async function getMaterialIssueList(
  params = {}
) {

  const response =
    await axiosClient.get(

      "/api/pms/task-material-issue/list",

      {
        params
      }
    );

  return response.data;
}